// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1s7E3","approved":"Status_approved__2mb-k","rejected":"Status_rejected__G4EtV","expired":"Status_expired__3tKMv","label":"Status_label__3Z5dd"};